/**
 * @module event-emitter
 *
 * @requires core
 * @requires es5-indexOf
 */
var core = require('core');
var indexOf = require('es5-indexOf');

/**
 * EventEmitter est une implementation synchrone du pattern observer
 *
 * @constructor EventEmitter
 * @memberOf module:event-emitter
 */
function EventEmitter() {
	this.events = {};
}

/**
 * @lends module:event-emitter.EventEmitter.prototype
 */
var EEProto = EventEmitter.prototype;

/**
 * Ajoute un event listener
 *
 * @param {String} eventName
 * @param {module:event-emitter.EventEmitter~eventListener} listener
 *
 * @returns EventEmitter
 */
EEProto.on = function(event, listener) {

	var listeners = this.events[event] || (this.events[event] = []);
	listeners.push(listener);
	return this;

};

/**
 * Ajoute un event listener destiné à n'être executer
 * qu'une seule fois
 *
 * @param {String} eventName
 * @param {module:event-emitter.EventEmitter~eventListener} listener
 *
 * @returns EventEmitter
 */
EEProto.once = function(event, listener) {

	var _this = this;

	this.on(event, function() {
		listener.apply(null, core.slice.call(arguments, 0));
		_this.off(event, listener);
	});

	return this;

};

/**
 * Retire un event listener correspondant au nom
 * d'event fourni.
 *
 * @param {String} eventName
 * @param {module:event-emitter.EventEmitter~eventListener} listener
 *
 * @returns EventEmitter
 */
EEProto.off = function(event, listener) {

	var listeners = this.events[event];
	if (listeners) {

		var index = indexOf(listeners, listener);
		if (index !== -1) {
			listeners.splice(index, 1);
			if (listeners.length === 0) {
				delete this.events[event];
			}
		}

	}

	return this;

};

/**
 * Emet un evenement et les paramètres associés
 *
 * @param {String} event
 * @param {...*} data
 */
EEProto.emit = function(event) {

	var args = core.slice.call(arguments, 0);
	args.splice(0, 1);

	var listeners = this.events[event];
	if (!listeners || !listeners.length) return;
	listeners = core.slice.call(listeners, 0);
	for (var i = 0, l = listeners.length; i < l; i++) {
		listeners[i].apply(null, args);
	}

};

/**
 * L'Event listener est appellé a chaque fois que l'event lui
 * correspondant est émit.
 *
 * @callback module:event-emitter.EventEmitter~eventListener
 * @param {...*} data
 */

module.exports = EventEmitter;
